<template>
  <v-dialog v-model="visible" max-width="95vw" max-height="95vh">
    <v-card>

      <!-- Toolbar -->
      <v-toolbar color="#00819d" dark>
        <v-toolbar-title>
          {{ filteredFotos.length }} puntos de control
        </v-toolbar-title>

        <v-spacer />

        <v-btn icon @click="tancar">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text>
        <v-container fluid>
          <!-- Selecció de fotos i canvi de client -->
          <v-row v-if="isAdmin && fotosSeleccionades.length" class="mb-3" align="center">
            <v-col cols="12" md="4">
              <v-text-field
                v-model="idCliente"
                density="compact"
                label="Id de cliente"
                placeholder="Introduce el Id de cliente"
                hide-details
                clearable
              />
            </v-col>

            <v-col cols="12" md="4">
              <div class="text-caption">
                Fotos seleccionadas:
                <strong>{{ fotosSeleccionades.length }}</strong>
              </div>
            </v-col>

            <v-col cols="12" md="4" class="d-flex justify-end">
              <v-btn
                color="primary"
                size="small"
                prepend-icon="mdi-content-save"
                :loading="assignantClient"
                :disabled="assignantClient || !idCliente"
                @click="assignarClientAFotosSeleccionades"
              >
                Guardar Id cliente
              </v-btn>
            </v-col>
          </v-row>

          <!-- Info + buscador + selector -->
          <v-row class="mb-2" align="center">
            <v-col cols="12" md="4">
              <div class="text-caption">
                Mostrant
                <strong>{{ filteredFotos.length ? startIndex + 1 : 0 }}</strong> -
                <strong>{{ Math.min(endIndex, filteredFotos.length) }}</strong>
                de <strong>{{ filteredFotos.length }}</strong> fotos
              </div>
            </v-col>

            <v-col cols="12" md="4">
              <v-text-field
                v-model="search"
                density="compact"
                label="Buscar"
                placeholder="Buscar per data o adreça"
                prepend-inner-icon="mdi-magnify"
                clearable
                hide-details
              />
            </v-col>

            <v-col cols="12" md="4" class="d-flex justify-end">
              <v-select
                :items="itemsPerPageOptions"
                v-model="itemsPerPage"
                density="compact"
                label="Puntos por página"
                style="max-width: 180px"
                hide-details
              />
            </v-col>
          </v-row>

          <!-- Graella -->
          <v-row>
            <v-col
              v-for="(foto, index) in renderedFotos"
              :key="`${startIndex + index}-${foto.fecha}-${foto.adreca}`"
              cols="12"
              sm="6"
              md="3"
            >
              <v-card elevation="1" class="pa-2">
                <div v-if="isAdmin" class="d-flex justify-end">
                  <!-- Escollir fotos -->
                  <v-checkbox
                    :model-value="isFotoSeleccionada(foto)"
                    density="compact"
                    hide-details
                    @update:model-value="toggleFotoSeleccionada(foto)"
                  />
                  <!-- Botó eliminar només admin -->
                  <v-btn
                      size=""
                      color="red"
                      variant="text"
                      prepend-icon="mdi-delete"
                      :loading="deletingId === foto.gid"
                      :disabled="deletingId === foto.gid"
                      @click="deleteFoto(foto)"
                    ></v-btn>
                </div>
                <!-- Imatge lazy real -->
                <v-img
                  v-if="foto.visible && foto.foto && !foto.loadError"
                  :src="foto.foto"
                  aspect-ratio="1"
                  max-height="250"
                  cover
                  loading="lazy"
                  @error="foto.loadError = true"
                />

                <!-- Placeholder -->
                <div
                  v-else
                  class="mb-2 d-flex align-center justify-center"
                  style="background:#1976d2;height:200px;color:white"
                >
                  <span>Carregant...</span>
                </div>

                  
  
                  
                  
                <!-- Info -->
                <div class="text-caption">
                  <p><strong>{{ foto.fecha }}</strong></p>
                  <p>{{ foto.adreca }}</p>
                </div>

              </v-card>
            </v-col>
          </v-row>

          <!-- Sense resultats -->
          <v-row v-if="!renderedFotos.length">
            <v-col cols="12" class="text-center text-caption py-8">
              No s'han trobat fotos.
            </v-col>
          </v-row>

          <!-- Paginador -->
          <v-row>
            <v-col cols="12" class="d-flex justify-center">
              <v-pagination
                v-model="page"
                :length="totalPages"
                :total-visible="7"
              />
            </v-col>
          </v-row>

        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { computed, ref, watch, nextTick } from 'vue'
import axios from 'axios'

/* ======================
   Eliminar foto
====================== */
const deletingId = ref(null)
const fotosSeleccionades = ref([])
const idCliente = ref('')
const assignantClient = ref(false)

const sessionData = computed(() => {
  try {
    return JSON.parse(localStorage.getItem('clientSession') || '{}')
  } catch {
    return {}
  }
})

const isAdmin = computed(() => sessionData.value?.role === 'admin')

// Canvi user FOTOS
function getFotoKey(foto) {
  return foto?.gid || `${foto?.fecha || ''}-${foto?.adreca || ''}-${foto?.foto || ''}`
}

function isFotoSeleccionada(foto) {
  const key = getFotoKey(foto)

  return fotosSeleccionades.value.some(item => getFotoKey(item) === key)
}

function toggleFotoSeleccionada(foto) {
  const key = getFotoKey(foto)
  const index = fotosSeleccionades.value.findIndex(item => getFotoKey(item) === key)

  if (index >= 0) {
    fotosSeleccionades.value.splice(index, 1)
    return
  }

  fotosSeleccionades.value.push(foto)
}

async function assignarClientAFotosSeleccionades() {
  if (!fotosSeleccionades.value.length) {
    alert('Selecciona como mínimo una foto.')
    return
  }

  if (!idCliente.value || !String(idCliente.value).trim()) {
    alert('Introduce el Id de cliente.')
    return
  }

  const gids = fotosSeleccionades.value
    .map(foto => foto.gid)
    .filter(Boolean)

  if (!gids.length) {
    alert('Les fotos seleccionades no tenen GID.')
    return
  }

  const ok = confirm(`Quieres assignar el Id de cliente "${idCliente.value}" a ${gids.length} fotos?`)
  if (!ok) return

  assignantClient.value = true

  try {
    await axios.patch(
      '/api/campaignsWeb/fotos/assign-client',
      {
        idclient: String(idCliente.value).trim(),
        gids,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      }
    )

    // Actualitzar també en pantalla sense recarregar
    renderedFotos.value = renderedFotos.value.map(foto => {
      if (gids.includes(foto.gid)) {
        return {
          ...foto,
          idclient: String(idCliente.value).trim()
        }
      }

      return foto
    })

    fotosSeleccionades.value = []
    idCliente.value = ''

    alert('Fotos actualitzades correctament.')
  } catch (e) {
    console.error('Error assignant client a fotos:', e?.response?.data || e)
    alert(e?.response?.data?.message || 'Error assignant l’Id de cliente a les fotos.')
  } finally {
    assignantClient.value = false
  }
}

// Esborrar fotos
async function deleteFoto(foto) {
  if (!foto?.gid) {
    alert('No se puede borrar esta foto, no tiene ID.')
    return
  }

  const ok = confirm('¿Seguro que quieres borrar esta foto?')
  if (!ok) return

  deletingId.value = foto.gid

  try {
    await axios.patch(
      `/api/campaignsWeb/fotos/${foto.gid}/disable`,
      {},
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      }
    )

    // Treure-la del llistat visible sense recarregar tota la pàgina
    renderedFotos.value = renderedFotos.value.filter(f => f.gid !== foto.gid)
    fotosSeleccionades.value = fotosSeleccionades.value.filter(f => f.gid !== foto.gid)

    // Important: avisar el pare perquè també l’elimini de llistatFotos
    emit('foto-deleted', foto.gid)
  } catch (e) {
    console.error('Error borrant foto:', e?.response?.data || e)
    alert('Error borrando la foto.')
  } finally {
    deletingId.value = null
  }
}

/* ======================
   Props / emits
====================== */
const props = defineProps({
  modelValue: { type: Boolean, required: true },
  llistatFotos: { type: Array, default: () => [] }
})

const emit = defineEmits(['update:modelValue', 'foto-deleted'])

const visible = computed({
  get: () => props.modelValue,
  set: v => emit('update:modelValue', v)
})

function tancar () {
  fotosSeleccionades.value = []
  idCliente.value = ''
  visible.value = false
}

/* ======================
   Buscador
====================== */
const search = ref('')

const filteredFotos = computed(() => {
  const text = search.value?.toLowerCase().trim()

  if (!text) return props.llistatFotos

  return props.llistatFotos.filter(foto => {
    const fecha = String(foto.fecha || '').toLowerCase()
    const adreca = String(foto.adreca || '').toLowerCase()

    return fecha.includes(text) || adreca.includes(text)
  })
})

/* ======================
   Paginació
====================== */
const page = ref(1)
const itemsPerPageOptions = [8, 12, 16]
const itemsPerPage = ref(12)

watch(
  () => [props.llistatFotos, itemsPerPage.value, search.value],
  () => {
    page.value = 1
  },
  { deep: true }
)

const totalPages = computed(() =>
  Math.max(1, Math.ceil(filteredFotos.value.length / itemsPerPage.value))
)

watch(totalPages, v => {
  if (page.value > v) page.value = v
})

const startIndex = computed(() => (page.value - 1) * itemsPerPage.value)
const endIndex = computed(() => startIndex.value + itemsPerPage.value)

const paginatedFotos = computed(() =>
  filteredFotos.value.slice(startIndex.value, endIndex.value)
)

/* ======================
   Render progressiu
====================== */
const renderedFotos = ref([])
const CHUNK_SIZE = 6

function waitForIdle () {
  return new Promise(resolve => {
    if ('requestIdleCallback' in window) {
      requestIdleCallback(resolve)
    } else {
      setTimeout(resolve, 0)
    }
  })
}

async function renderInChunks () {
  renderedFotos.value = []

  const fotos = paginatedFotos.value.map(f => ({
    ...f,
    visible: false,
    loadError: false
  }))

  for (let i = 0; i < fotos.length; i += CHUNK_SIZE) {
    const chunk = fotos.slice(i, i + CHUNK_SIZE)
    renderedFotos.value.push(...chunk)

    await nextTick()
    await waitForIdle()
  }

  // Activar càrrega real quan ja estan pintades
  renderedFotos.value.forEach(f => {
    f.visible = true
  })
}

watch(
  [paginatedFotos, visible],
  () => {
    if (visible.value) {
      renderInChunks()
    }
  },
  { immediate: true }
)
</script>